export default {
  title: 'Demander une facture',
  form: {
    is_receipt_required: {
      label: 'Demander une facture par e-mail',
    },
    company_name: {
      placeholder: "Nom de l'entreprise (facultatif)",
    },
    first_name: {
      placeholder: 'Prénom',
    },
    last_name: {
      placeholder: 'Nom',
    },
    address: {
      placeholder: 'Rue + numéro',
    },
    zip_code: {
      placeholder: 'Code postal',
    },
    city: {
      placeholder: 'Ville',
    },
    tax_id: {
      placeholder: 'Numéro de TVA',
    },
    email: {
      placeholder: 'Adresse e-mail',
    },
  },
};
